<div *ngIf="!fileImportTO">
    <h2>Upload Sprout Form</h2>

    <p>You can use this tool to import form definitions into Sprout using a specially
        formatted Excel document. The Excel document specification can be found here, ....</p>

    <sprout-form-upload (fileImportTO)="setFileImportTO($event)"></sprout-form-upload>

</div>

<div *ngIf="fileImportTO">
    <h2>{{fileImportTO.formName}} form</h2>
    <sprout-forms *ngIf="fileImportTO" [model]="fileImportTO"></sprout-forms>
</div>

